// @flow

import { combineReducers } from 'redux';
import data, { type State as Data } from 'app/common/redux/reducers/resources/data';
import fetching, { type State as Fetching } from 'app/common/redux/reducers/resources/fetching';

export type State = {
  fetching: Fetching,
  data: Data,
};

// $FlowFixMe: new errors found from flow 0.96 upgrade
const resources = combineReducers({
  fetching,
  data,
});

export default resources;
